import form from './form';
import table from './table';

export default {
  layout: 'cme-training-layout',
  form,
  table,
};
